import * as constants from '../constants/actions';

const initialState = {
  alertOpen: false,
  alertText: '',
  alertConfig: {},
  modalResize: 0,
  currentScrollTop: 0,
  lastScrollInc: 0.0,
  lastScrollPos: 0,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case constants.COMMON_ALERT:
      return commonOpenAlert(state, action);
    case constants.COMMON_CLOSE_ALERT:
      return commonCloseAlert(state, action);
    case constants.COMMON_MODAL_RESIZE:
      return commonModalResize(state, action);
    case constants.COMMON_SCROLL_TOP:
      return commonScrollTop(state, action);
    case constants.COMMON_SCROLL_TO:
      return commonScrollTo(state, action);
    default:
      return state;
  }
}

function commonOpenAlert(state, action) {
  return Object.assign({}, state, {
    alertOpen: true,
    alertText: action.text,
    alertConfig: action.config,
  });
}

function commonCloseAlert(state, action) {
  return Object.assign({}, state, {
    alertOpen: false,
    alertText: '',
    alertConfig: {},
  });
}

function commonModalResize(state, action) {
  return Object.assign({}, state, {
    modalResize: state.modalResize + 0.1,
  });
}

function commonScrollTop(state, action) {
  return Object.assign({}, state, {
    currentScrollTop: action.scroll,
  });
}

function commonScrollTo(state, action) {
  return Object.assign({}, state, {
    lastScrollPos: action.scrollPos,
    lastScrollInc: state.lastScrollInc + 0.1,
  });
}